import { FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { getTranslatedString } from "./FindifyTranslatedString";
import { Share } from "react-native";

export const sharePlace = async (findifyDataContext: FindifyDataContextType) => {
    const result = await Share.share({
        title: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
        message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}`,
    }, {
        dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
    });
}
export const toggleFavouriteWorkspace = (findifyDataContext: FindifyDataContextType) => {
    if (findifyDataContext?.favouriteWorkspaces.includes(findifyDataContext?.workspace?.workspace_id)) {
        findifyDataContext?.setFavouriteWorkspaces(findifyDataContext?.favouriteWorkspaces.filter((id) => id !== findifyDataContext?.workspace?.workspace_id));
    } else {
        findifyDataContext?.setFavouriteWorkspaces([...findifyDataContext.favouriteWorkspaces, findifyDataContext?.workspace?.workspace_id]);
    }
}


